import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators, compose } from 'redux'
import { connect } from 'react-redux'
import CoreLayout from './coreLayout'
import { hasRole } from '../utils/helpers'
import LoadingIndicator from '../components/loadingIndicator'
import Messages from '../constants/messages'
import NordAppBar from '../components/nordAppBar'
import { partnerAccessAll } from '../constants/memberships'
import { push } from 'react-router-redux'
import SideNavigation from '../components/sideNavigation'
import { setMenuAnchorElement, setShowProfileMenu, logout } from '../modules/authProfile'
import { setShowContext } from '../modules/appContext'
import withStyles from 'material-ui/styles/withStyles'
import { withRouter } from 'react-router-dom'

const PROP_TYPES = {
  app: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  changePage: PropTypes.func.isRequired,
  firstName: PropTypes.string,
  hasLoadedAppData: PropTypes.bool.isRequired,
  heading: PropTypes.string.isRequired,
  isLoading: PropTypes.bool.isRequired,
  lastName: PropTypes.string,
  logout: PropTypes.func.isRequired,
  menuAnchorElement: PropTypes.object.isRequired,
  setMenuAnchorElement: PropTypes.func.isRequired,
  setShowContext: PropTypes.func.isRequired,
  setShowProfileMenu: PropTypes.func.isRequired,
  showProfileMenu: PropTypes.bool.isRequired,
  userMemberships: PropTypes.array.isRequired,
  userRoles: PropTypes.array.isRequired
}

const styles = theme => ({
  appFrame: {
    position: 'relative',
    display: 'flex',
    width: '100%',
    height: '100%',
  },
  content: {
    backgroundColor: theme.palette.background.default,
    width: '100%',
    padding: theme.spacing.unit * 3,
    height: 'calc(100% - 56px)',
    [theme.breakpoints.up('sm')]: {
      height: 'calc(100% - 64px)',
      marginTop: 64,
    }
  }
})

const version = process.env.VERSION || '#.#.#-#'

export class MainLayout extends Component {

  render() {
    const {
      app,
      changePage,
      classes,
      clientList,
      component,
      firstName,
      hasLoadedAppData,
      heading,
      isLoading,
      lastName,
      logout,
      menuAnchorElement,
      partners,
      setMenuAnchorElement,
      setShowContext,
      setShowProfileMenu,
      showProfileMenu,
      userMemberships,
      userRoles,
      ...rest
    } = this.props
    const Component = this.props.component
    const isAssignmentButtonDisabled = hasRole(userRoles, partnerAccessAll) && (!clientList || (clientList && clientList.length <= 1))
    const layout = !hasLoadedAppData ? <LoadingIndicator infoText={Messages['uiComponents']['LOADING_MSG']} /> :
      <CoreLayout {...rest} component={matchProps => (
        <div className={classes.appFrame}>
          <NordAppBar
            appName={app.name}
            changePage={changePage}
            isAssignmentButtonDisabled={isAssignmentButtonDisabled}
            heading={heading}
            firstName={firstName}
            lastName={lastName}
            logout={logout}
            menuAnchorElement={menuAnchorElement}
            partners={partners}
            setMenuAnchorElement={setMenuAnchorElement}
            setShowContext={setShowContext}
            setShowProfileMenu={setShowProfileMenu}
            showProfileMenu={showProfileMenu}
            userMemberships={userMemberships}
            userRoles={userRoles} />
          <SideNavigation
            appName={app.name}
            appUrl={app.url}
            changePage={changePage}
            userMemberships={userMemberships}
            userRoles={userRoles}
            version={version} />
          { isLoading ? <LoadingIndicator infoText={Messages['uiComponents']['LOADING_MSG']} /> :
            <main className={classes.content}>
              <Component {...matchProps} />
            </main>
          }
        </div>
      )} />
    return layout
  }
}

MainLayout.propTypes = PROP_TYPES

const mapStateToProps = state => ({
  app: state.appContext.appInfo,
  clientList: state.client.clientList,
  firstName: state.authProfile.firstName,
  hasLoadedAppData: state.loading.hasLoadedAppData,
  heading: state.navigation.currentPageHeading,
  isLoading: state.loading.isLoading,
  lastName: state.authProfile.lastName,
  menuAnchorElement: state.authProfile.menuAnchorElement,
  partners: state.authProfile.partners,
  showProfileMenu: state.authProfile.showProfileMenu,
  userMemberships: state.authProfile.userMemberships,
  userRoles: state.authProfile.userRoles
})

const mapDispatchToProps = dispatch => bindActionCreators({
  changePage: (route) => push(route),
  logout,
  setMenuAnchorElement,
  setShowContext,
  setShowProfileMenu
}, dispatch)

export default withRouter(
    compose(
      withStyles(styles),
      connect(
        mapStateToProps,
        mapDispatchToProps
      )
)(MainLayout))
